import { Component, input, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
  selector: 'portal-loading-indicator-container',
  templateUrl: './loading-indicator-container.component.html',
  styles: [],
  standalone: false,
})
export class LoadingIndicatorContainerComponent implements OnChanges, OnInit {
  @Input()
  loading: boolean = true;

  onlyInitial = input<boolean>(false);

  @Input()
  opaque: boolean = false;

  /**
   * Hide the content until the component has been rendered at least once
   */
  firstLoad: boolean = true;
  timeout: number | null = null;

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('loading' in changes) {
      if (this.firstLoad === false && this.onlyInitial()) {
        return;
      }

      if (changes.loading.currentValue === false) {
        if (this.timeout) {
          // Setting showLoadingIndicator to false will switch the template and therefore would hide the :leave animation
          setTimeout(() => {
            this.firstLoad = false;
          }, 200);
        } else {
          this.firstLoad = false;

          clearTimeout(this.timeout);
          this.timeout = null;
        }
      }
    }
  }

  ngOnInit() {
    this.opaque = this.opaque !== false;

    this.timeout = window.setTimeout(() => {
      this.timeout = null;
    }, 100);
  }
}
